import { Observable } from 'rxjs';
import { IListResult } from '../list-result/list-result.interface';
import { IPayment } from './payment.interface';

export abstract class IPaymentSource {

  abstract getPaymentMethods(): Observable<IListResult<IPayment>>;

}
